// extracted by mini-css-extract-plugin
var _1 = "PhaseStripSkeleton-modulerow__ehYnQ";
export { _1 as "row" }
